import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Icon } from '../icons';
import { COLORS, FONT_FAMILY, TYPOGRAPHY } from '../constants/color';
import axios from 'axios';
import { url } from '../constants/url';
import { useAuth } from '../context/authContext';

const ClientNotificationBanner = ({ prependContent }) => {
    const { userData, token } = useAuth();
    const [notificationMsg, setNotificationMsg] = useState("");

    useEffect(() => {
        // Only fetch for clients
        if (userData?.role === "CLIENT" && token) {
            const fetchNotification = async () => {
                try {
                    const res = await axios.get(`${url}/api/general/content/CLIENT_NOTIFICATION`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    if (res.data?.data) {
                        const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                        if (data?.content) {
                            setNotificationMsg(data.content);
                        }
                    }
                } catch (error) {
                    console.error("Failed to fetch client notification", error);
                }
            };

            fetchNotification();
        }
    }, [userData?.role, token]);

    if (userData?.role !== "CLIENT" || (!notificationMsg && !prependContent)) return null;

    return (
        <Box
            sx={{
                backgroundColor: '#FFF3E0',
                borderRadius: '4px',
                p: 2,
                mb: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                justifyContent: "center"
            }}
        >
            <Icon name="info" color={COLORS.ERROR} size={20} />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'center' }}>
                {prependContent && (
                    <Typography
                        sx={{
                            ...TYPOGRAPHY.H4,
                            fontFamily: FONT_FAMILY,
                            color: COLORS.ERROR,
                            fontWeight: 500,
                            textAlign: "center"
                        }}
                    >
                        {prependContent}
                    </Typography>
                )}

                {notificationMsg && (
                    <Typography
                        sx={{
                            ...TYPOGRAPHY.H4,
                            fontFamily: FONT_FAMILY,
                            color: COLORS.ERROR,
                            fontWeight: 500,
                            textAlign: "center",
                            whiteSpace: "pre-line"
                        }}
                    >
                        {notificationMsg}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default ClientNotificationBanner;
